export const REGISTERRECRUITER_REQUEST = 'RegisterRecruiterReducer/REGISTERRECRUITER_REQUEST';
export const REGISTERRECRUITER_SUCCESS = 'RegisterRecruiterReducer/REGISTERRECRUITER_SUCCESS';
export const REGISTERRECRUITER_FAILED = 'RegisterRecruiterReducer/REGISTERRECRUITER_FAILED';
